<template>
  <OutOfStock
    v-if="isOutOfStock && productResponse"
    :alternative="outOfStockAlternative"
    :breadcrumb="breadcrumbResponse?.breadcrumb ?? []"
    class="ps-24 md:ps-0"
    :is-alternative-loading="outOfStockAlternativeLoading"
    :product="productResponse"
    :ratings="ratesResponse"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import OutOfStock from '~/scopes/product-core/components/presentationals/OutOfStock/OutOfStock.vue'
import { useFetchBreadcrumb } from '~/scopes/product-core/composables/useFetch/useFetchBreadcrumb/useFetchBreadcrumb'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchReviewsSummary } from '~/scopes/product-core/composables/useFetch/useFetchReviewsSummary/useFetchReviewsSummary'

const { isOutOfStock } = useFetchPickers()
const { data: productResponse } = useFetchProduct()
const { data: breadcrumbResponse } = useFetchBreadcrumb()
const { data: ratesResponse } = useFetchReviewsSummary()

// @FIXME: Implement the alternative product
const outOfStockAlternative = computed(() => {
  return null
})
// @FIXME: Implement the alternative product
const outOfStockAlternativeLoading = computed(() => {
  return false
})
</script>
